import React, { useState } from "react";
import "./Home.scss";

export default function Home() {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  function openModal(imageSrc:string) {
    setSelectedImage(imageSrc);
    setModalIsOpen(true);
  };

  function closeModal() {
    setModalIsOpen(false);
    setSelectedImage("");
  };

  return (
    <div className="under-header">
      <div className="images">
        <a href="http://www.gpsatsys.com.au/">
          <img
            className="images"
            src="assets/images/griffin.gif"
            alt="Griffin Logo"
            height={300}
          />
        </a>
      </div>
      <div className="content box-title">
        <div className="box-heading">
          <p className="contentTitle heading">
            GNSS RF Interference Finder (GRIFFIN) System
          </p>
        </div>
        <p className="contentTitle">About - GRIFFIN</p>
        <p className="contentBody">
          The GRIFFIN system consists of one or several Sensor/ Monitoring Nodes
          installed surrounding a regional area encompassing mission critical
          GNSS applications that require protection. Typically, Sensor Nodes
          (SN) are installed around the perimeter. Each Sensor Node’s RF 360deg
          azimuth searching using both the electronically steerable antenna
          arrays and advanced signal processing techniques.
        </p>
        <p className="contentBody">
          RFI source in the GPS frequency bands is quickly detected within
          seconds. The relative direction to a SN and type of interference is
          quickly and automatically passed to the appropriate authorities to
          deliver the required remedial action.
        </p>
        <p className="contentBody">
          Multi element electronic antenna arrays for facilitating infinite
          combinations of rapidly switchable high gain (20+dBi) beams and/or
          deep nulls for complex directional patterns. The synthetic directional
          beams facilitate both intense focusing on the RFI targets and GNSS
          satellites during intentional signal acquisition. Then under different
          circumstances, deep nulls are used to reject GNSS satellites
          (considered unwanted background noise) while focusing on weak RFI
          targets at long distances.
        </p>
        <p className="contentBody">
          Real-time status of all the SNs and recorded interference event
          reports are available via a centralized webpage on Internet. The
          recorded event reports are downloadable as offline HTML files allowing
          customers to review the events interactively.
        </p>
        <br />
      </div>
      <div className="image-grid">
        <div className="image-container">
          <img
            className="images"
            src="assets/images/screenshot1.png"
            alt="Griffin image 1"
            height={300}
            onClick={() => openModal("assets/images/screenshot1.png")}
          />
        </div>
        <div className="image-container">
          <img
            className="images"
            src="assets/images/screenshot2.png"
            alt="Griffin image 2"
            height={300}
            onClick={() => openModal("assets/images/screenshot2.png")}
          />
        </div>
        <div className="image-container">
          <img
            className="images"
            src="assets/images/screenshot3.png"
            alt="Griffin image 3"
            height={300}
            onClick={() => openModal("assets/images/screenshot3.png")}
          />
        </div>
      </div>
      {modalIsOpen && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="Enlarged" />
            <button className="modal-close" onClick={closeModal}>
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
